<!-- PostPlaybackOverlay.vue -->
<template>
    <div
      v-if="visible"
      class="post-playback-overlay"
      :class="{ 'fade-in': visible }"
    >
      <div class="overlay-backdrop"></div>

      <div class="overlay-content">
        <div class="completed-message">
          <div class="completion-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <h2 class="completion-title">Conversation Complete</h2>
          <p class="completion-subtitle">What would you like to do next?</p>
        </div>

        <div class="action-buttons">
          <button
            class="action-button share-button"
            @click="$emit('share')"
            aria-label="Share conversation"
          >
            <div class="button-content">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
                <polyline points="16 6 12 2 8 6"></polyline>
                <line x1="12" y1="2" x2="12" y2="15"></line>
              </svg>
              <span>Share</span>
            </div>
          </button>

          <button
            class="action-button embed-button"
            @click="$emit('embed')"
            aria-label="Embed conversation"
          >
            <div class="button-content">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="16 18 22 12 16 6"></polyline>
                <polyline points="8 6 2 12 8 18"></polyline>
              </svg>
              <span>Embed</span>
            </div>
          </button>

          <button
            class="action-button like-button"
            :class="{ 'active': userFeedback === 'like' }"
            @click="$emit('like')"
            aria-label="Like conversation"
          >
            <div class="button-content">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>
              </svg>
              <span>Like</span>
            </div>
          </button>

          <button
            class="action-button dislike-button"
            :class="{ 'active': userFeedback === 'dislike' }"
            @click="$emit('dislike')"
            aria-label="Dislike conversation"
          >
            <div class="button-content">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path>
              </svg>
              <span>Dislike</span>
            </div>
          </button>
        </div>

        <div class="replay-section">
          <button
            class="replay-button"
            @click="$emit('replay')"
            aria-label="Replay conversation"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="1 4 1 10 7 10"></polyline>
              <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
            </svg>
            <span>Replay Conversation</span>
          </button>
        </div>

        <div class="close-section">
          <button
            class="close-button"
            @click="$emit('close')"
            aria-label="Close overlay"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'PostPlaybackOverlay',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      userFeedback: {
        type: String,
        default: null
      }
    }
  }
  </script>

  <style scoped>
  .post-playback-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    overflow: hidden;
    border-radius: 0.5rem;
    opacity: 0;
    transition: opacity 0.5s ease;
  }

  .post-playback-overlay.fade-in {
    opacity: 1;
  }

  .overlay-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(5px);
    z-index: 1001;
  }

  .overlay-content {
    position: relative;
    z-index: 1002;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4rem;
    width: 100%;
    max-width: 600px;
    text-align: center;
    margin-top: 1rem;
  }

  @keyframes slideDown {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.post-playback-overlay.fade-in .overlay-content {
  animation: slideDown 0.5s ease forwards;
}

/* You might also want to add a subtle visual indicator pointing down */
.scroll-indicator {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  opacity: 0.7;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0) translateX(-50%);
  }
  40% {
    transform: translateY(-10px) translateX(-50%);
  }
  60% {
    transform: translateY(-5px) translateX(-50%);
  }
}

  .completed-message {
    margin-bottom: 2rem;
    color: white;
  }

  .completion-icon {
    display: inline-flex;
    background: rgba(59, 130, 246, 0.2);
    padding: 1rem;
    border-radius: 50%;
    color: #4299E1;
    margin-bottom: 1rem;
    animation: pulse 2s infinite;
  }

  .completion-title {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  .completion-subtitle {
    font-size: 1rem;
    opacity: 0.9;
  }

  .action-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .action-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    border-radius: 0.5rem;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 120px;
  }

  .action-button:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-5px);
  }

  .button-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
  }

  .action-button span {
    font-size: 0.9rem;
    font-weight: 500;
  }

  .action-button.active {
    background: rgba(59, 130, 246, 0.3);
    box-shadow: 0 0 15px rgba(59, 130, 246, 0.5);
  }

  .share-button:hover {
    background: rgba(59, 130, 246, 0.3);
  }

  .embed-button:hover {
    background: rgba(139, 92, 246, 0.3);
  }

  .like-button:hover, .like-button.active {
    background: rgba(16, 185, 129, 0.3);
  }

  .like-button.active svg {
    fill: #10B981;
    stroke: #10B981;
  }

  .dislike-button:hover, .dislike-button.active {
    background: rgba(239, 68, 68, 0.3);
  }

  .dislike-button.active svg {
    fill: #EF4444;
    stroke: #EF4444;
  }

  .replay-section {
    margin-bottom: 1.5rem;
  }

  .replay-button {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    background: rgba(59, 130, 246, 0.2);
    border: 1px solid rgba(59, 130, 246, 0.5);
    border-radius: 9999px;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .replay-button:hover {
    background: rgba(59, 130, 246, 0.4);
    transform: translateY(-2px);
  }

  .close-section {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }

  .close-button {
    background: rgba(255, 255, 255, 0.1);
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .close-button:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: rotate(90deg);
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.4);
    }
    70% {
      box-shadow: 0 0 0 15px rgba(59, 130, 246, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
    }
  }

  /* Responsive styles */
  @media (max-width: 768px) {
    .action-buttons {
      grid-template-columns: repeat(2, 1fr);
    }

    .action-button {
      width: 110px;
    }
  }

  @media (max-width: 480px) {
    .overlay-content {
      padding: 1.5rem;
    }

    .action-buttons {
      gap: 0.75rem;
    }

    .action-button {
      width: 100px;
      padding: 0.75rem;
    }

    .completion-title {
      font-size: 1.25rem;
    }

    .completion-subtitle {
      font-size: 0.9rem;
    }
  }
  </style>
